import { AgendaItemType } from '@graphql/gql/graphql';

/**
 * Extracts agenda item information for reminders to display
 */
const filterUpNextReminders = (
  activeReminders = [],
  agendaItems = [],
  now = new Date().toISOString()
) => {
  const nowDate = new Date(now);

  // Generate look-up map
  const agendaItemById = agendaItems.reduce((acc, agendaItem) => {
    return {
      ...acc,
      [agendaItem.id]: agendaItem
    };
  }, {});

  const upNextAgendaItems = [];
  const validReminderMessageIds = [];
  const invalidReminderMessageIds = [];
  activeReminders.forEach(activeReminder => {
    const agendaItem = agendaItemById[activeReminder.itemId];

    if (!agendaItem) {
      invalidReminderMessageIds.push(activeReminder.messageId);
      return;
    }

    // Verify sessions are either included or enrolled
    if (
      agendaItem.type === 'SESSION' &&
      !agendaItem.included &&
      !agendaItem.enrolled
    ) {
      invalidReminderMessageIds.push(activeReminder.messageId);
      return;
    }

    // Fail-safe: Make sure the agenda item hasn't ended
    const end = new Date(agendaItem.end);
    if (nowDate > end) {
      invalidReminderMessageIds.push(activeReminder.messageId);
      return;
    }
    validReminderMessageIds.push(activeReminder.messageId);
    upNextAgendaItems.push(agendaItem);
  });

  // if agendaItem.type is not present, explicitly add agendaItem.type since downstream methods expect a 'type' property
  upNextAgendaItems.forEach((agendaItem, index) => {
    const item = {
      ...agendaItem,
      type: agendaItem?.type ?? AgendaItemType.Session
    };
    upNextAgendaItems[index] = item;
  });

  return {
    upNextAgendaItems,
    validReminderMessageIds,
    invalidReminderMessageIds
  };
};

export default filterUpNextReminders;
